export class AppError extends Error {
    codigo;
    mensaje;
    status;
    requestId;
    errores;
    constructor(codigo, mensaje, status, requestId, errores) {
        super(mensaje);
        this.codigo = codigo;
        this.mensaje = mensaje;
        this.status = status;
        this.requestId = requestId;
        this.errores = errores;
        this.name = 'AppError';
    }
    static desconocido(causa) {
        const mensaje = causa instanceof Error ? causa.message : 'Error desconocido';
        return new AppError('INTERNO_DESCONOCIDO', mensaje);
    }
}
